import {Routes} from '@angular/router';
import {NoWorkspacePageComponent} from './pages/no-workspace-page.component';

export const noWorkspaceRoutes: Routes = [
  { path: '', component: NoWorkspacePageComponent }
];
